import { MEDIA, MEDIA_DETAIL } from "../actions/Actions";

const initalState = {
  listLoader: false,
  listCount: null,
  list: [],
  detailLoader: false,
  detail: null,
};

export function mediaReducer(state = initalState, action) {
  const { type, payload } = action;

  switch (type) {
    // GET
    case MEDIA.LOADING:
      return {
        ...state,
        listLoader: true,
      };
    case MEDIA.SUCCESS:
      return {
        ...state,
        listLoader: false,
        listCount: payload.total,
        list: payload.rows,
      };
    case MEDIA.ERROR:
      return {
        ...state,
        listLoader: false,
      };

    // MEDIA_DETAIL
    case MEDIA_DETAIL.LOADING:
      return {
        ...state,
        detailLoader: true,
        detail: null,
      };
    case MEDIA_DETAIL.SUCCESS:
      return {
        ...state,
        detailLoader: false,
        detail: payload,
      };
    case MEDIA_DETAIL.ERROR:
      return {
        ...state,
        detailLoader: false,
      };

    default:
      return state;
  }
}
